export default __webpack_public_path__ + "static/1-a4f9b4923dea52aa27ffff3fea1dac60.jpeg";